document.addEventListener("DOMContentLoaded", () => {
  /**
   * 🔹 Initialize swatches
   */
  function initializeSwatches(scope = document) {
    const swatchBlocks = scope.querySelectorAll(".card-wrapper .color-swatches");
    if (!swatchBlocks.length) return;

    for (const block of swatchBlocks) {
      const btns = block.querySelectorAll(".quick-add__submit.button:not([aria-haspopup])");
      btns.forEach(btn => btn.setAttribute("aria-haspopup", "dialog"));

      const firstLabel = block.querySelector(".swatch-label");
      if (!firstLabel) continue;

      const swatch = firstLabel.querySelector(".swatch");
      const selectedColor = swatch?.getAttribute("title");
      const wishlistButton = block.closest(".card-wrapper")?.querySelector(".wishlist_button");

      if (wishlistButton && selectedColor) {
        wishlistButton.dataset.selectedVariantValue = selectedColor;
      }

      firstLabel.classList.add("active");
      const radio = firstLabel.querySelector(".swatch-radio");
      if (radio) {
        radio.checked = true;
      }
    }
  }

  /**
   * 🕐 Wait for swatches to exist before initializing
   */
  function waitForSwatches(scope = document, retries = 10) {
    requestIdleCallback(() => {
      const swatches = scope.querySelectorAll(".card-wrapper .color-swatches .swatch-label");
      if (swatches.length) {
        initializeSwatches(scope);
      } else if (retries > 0) {
        setTimeout(() => waitForSwatches(scope, retries - 1), 100);
      }
    }, { timeout: 500 });
  }

  /**
   * 🖼️ Non-blocking variant image change
   */
  const updateVariantImage = (cardWrapper, variant) => {
    if (!variant?.variant_image.length || !variant?.variant_image[0]) return;
    const primaryImage = variant.variant_image[0];
    const images = cardWrapper.querySelectorAll(".main-img");
    if (!images.length) return;

    const generateSrcSet = (url) => {
      const widths = [165, 360, 533, 720, 940, 1066, 1710];
      return widths.map(w => `${url}&width=${w} ${w}w`).join(", ");
    };
    const srcset = generateSrcSet(primaryImage);

    requestAnimationFrame(() => {
      images.forEach(img => {
        img.src = `${primaryImage}&width=533`;
        img.srcset = srcset;
        img.sizes = "(min-width: 768px) 533px, 100vw";
      });
    });
  };

  /**
   * 🧠 Swatch click delegation (lightweight, global)
   */
  document.addEventListener("click", (e) => {
    const label = e.target.closest(".card-wrapper .color-swatches .swatch-label");
    if (!label) return;

    const card = label.closest(".card-wrapper");
    const radio = label.querySelector(".swatch-radio");
    const variantId = radio?.value;
    const color = label.querySelector(".swatch")?.getAttribute("title");

    // Update active states
    label.parentElement.querySelectorAll(".swatch-label").forEach(l => l.classList.remove("active"));
    label.classList.add("active");

    const form = card?.querySelector(".card_product_add_to_card form");
    const input = form?.querySelector("input[name='id']");
    const wishlistBtn = card?.querySelector(".wishlist_button");
    const addBtn = card?.querySelector(".quick-add__submit.button");

    if (input && variantId) input.value = variantId;
    if (wishlistBtn && variantId) {
      wishlistBtn.dataset.productVariantId = variantId;
      if (color) wishlistBtn.dataset.selectedVariantValue = color;
    }
    if (addBtn) addBtn.disabled = !variantId;

    // Change image after idle
    const jsonData = card?.querySelector("#product-variants-data")?.textContent;
    if (jsonData && variantId) {
      requestIdleCallback(() => {
        try {
          const variants = JSON.parse(jsonData);
          const variant = variants.find(v => v.id == variantId);
          updateVariantImage(card, variant);
        } catch (err) {
          console.warn("⚠️ Variant JSON parse failed:", err);
        }
      });
    }
  });

  /**
   * 🔁 Observe product grid (Infinite scroll / AJAX)
   */
  function observeInfiniteScroll() {
    const grid = document.querySelector(".product-grid");
    if (!grid) return;

    const observer = new MutationObserver((mutations) => {
      let newProducts = false;
      for (const m of mutations) {
        if ([...m.addedNodes].some(n => n.nodeType === 1 && n.querySelector?.(".card-wrapper"))) {
          newProducts = true;
          break;
        }
      }

      if (newProducts) {
        requestIdleCallback(() => waitForSwatches(grid), { timeout: 800 });
      }
    });

    observer.observe(grid, { childList: true, subtree: true });
    requestIdleCallback(() => waitForSwatches(grid), { timeout: 400 });
  }

  /**
   * 🧩 Handle Shopify dynamic section reloads
   */
  document.addEventListener("shopify:section:load", (e) => waitForSwatches(e.target));

  /**
   * 🚀 Start observers after short delay
   */
  setTimeout(() => {
    waitForSwatches(document);
    observeInfiniteScroll();
  }, 300);
});
